import React from 'react'


function Revolution() {

  return (
    <div className='mt-10 flex flex-col items-center h-full'>
      <h1 className='mb-0 md:mb-3 text-xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-sky-500 to-blue-500 uppercase'>Bird Meta Revolution</h1>
      <p className='p-10 text-lg md:text-xl max-w-xl md:max-w-5xl text-justify'>Birds inside the Stone are making the next Meta innovation. Our goal is to solve the current investors issues. In other words, make an NFT trader's life easier, we do all the work for you, you decide whether to jump on projects or not.</p>

      <div className='m-5 flex items-center space-x-0 md:space-x-4 justify-between flex-wrap'>
        <div className='mb-6 overflow-hidden flex flex-col items-center justify-center w-110 md:w-100'>
          <img src='/images/1analytic.png' alt='' className='' />
          <h2 className='pb-4 font-bold text-transparent bg-clip-text bg-gradient-to-l from-green-400 via-green-700 to-blue-900'>ANALYTICS AND INSIGHTS</h2>
           <p className='text-lg md:text-xl text-center'>Analyse NFT collections using indicators tracking whales and the market&apos;s trades.</p>
        </div>
        <div className='mb-6 overflow-hidden flex flex-col items-center justify-center w-110 md:w-100'>
          <img src='/images/2alert.png' alt='' className=''/>
          <h2 className='pb-4 font-bold text-transparent bg-clip-text bg-gradient-to-l from-green-400 via-green-700 to-blue-900'>ALERTS AND SIGNALS</h2>
          <p className='text-lg md:text-xl text-center'>Making alert calls when a floor pump or dump call is made in private groups of whales.</p>
        </div>
        <div className='mb-6 overflow-hidden flex flex-col items-center justify-center w-110 md:w-100'>
          <img src='/images/3review.png' alt='' className='mb-1'/>
          <h2 className='pb-4 font-bold text-transparent bg-clip-text bg-gradient-to-l from-green-400 via-green-700 to-blue-900'>REVIEWING AND REVISING</h2>
          <p className='text-lg md:text-xl text-center'>Reviewing the volume, floor price compared to mint price, team&apos;s follow up on road maps.</p>
        </div>
        <div className='mb-6 overflow-hidden flex flex-col items-center justify-center w-110 md:w-100'>
          <img src='/images/4report.png' alt='' className='mb-1'/>
          <h2 className='pb-4 font-bold text-transparent bg-clip-text bg-gradient-to-l from-green-400 via-green-700 to-blue-900'>REPORTS AND INDEXES</h2>
          <p className='text-lg md:text-xl text-center'>Reports of projects&apos;s future releases or drops. Indexes identifying the market&apos;s performance.</p>
        </div>
      </div>
    </div>
  )
}

export default Revolution